// extracted by mini-css-extract-plugin
module.exports = {"container":"panel-module--container--T8sBU"};